"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var index_1 = require("../../index");
var styles_1 = require("./styles");
function ToggleButton(props) {
    var _a = index_1.useDropdown(), setIsMenuOpen = _a.setIsMenuOpen, setTriggerButtonElement = _a.setTriggerButtonElement, setTriggerButtonRef = _a.setTriggerButtonRef;
    var children = props.default
        ? __spreadArrays(new Array(3)).map(function (_, index) { return react_1.default.createElement(styles_1.Dot, { key: index }); })
        : props.children;
    return (react_1.default.createElement(styles_1.Button, { default: props.default, ref: function (reference) {
            setTriggerButtonElement(reference);
            return setTriggerButtonRef(reference);
        }, onClick: function (event) {
            event.stopPropagation();
            event.preventDefault();
            setIsMenuOpen(true);
        }, style: props.style, className: props.className }, children));
}
exports.default = ToggleButton;
//# sourceMappingURL=index.js.map